import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  {
    quote: "AB & Co took the dread out of our year-end. Everything was filed early, explained in plain English, and our tax bill came in lower than we expected.",
    name: "Sinéad O'Connell",
    role: "Boutique Owner, Kilkenny",
    testid: "testimonial-1",
  },
  {
    quote: "They have handled our payroll and VAT for three years now. One phone call and it is sorted — I honestly could not recommend them enough.",
    name: "Patrick Byrne",
    role: "Director, Byrne Construction Ltd",
    testid: "testimonial-2",
  },
  {
    quote: "As a new business we needed more than an accountant — we needed advice. They mapped out our cash flow and got us properly investor-ready.",
    name: "Aoife Murphy",
    role: "Co-founder, Greenway Foods",
    testid: "testimonial-3",
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1] },
};

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="border-t hairline-gold py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div {...fadeUp}>
          <p className="overline-label mb-6 flex items-center gap-4" data-testid="testimonials-overline">
            <span className="inline-block h-px w-10 bg-gold" />
            Client Words
          </p>
          <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-navy sm:text-5xl" data-testid="testimonials-heading">
            Trusted, in their<br /><em className="italic text-gold">own words.</em>
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 gap-0 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.testid}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: i * 0.15 }}
              className={`flex flex-col justify-between border-t hairline-gold py-10 lg:border-t-0 lg:px-10 lg:py-4 ${
                i > 0 ? "lg:border-l" : "lg:pl-0"
              }`}
              data-testid={t.testid}
            >
              <div>
                <div className="flex gap-1.5" aria-label="5 out of 5 stars">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={15} className="fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="mt-7 font-serif text-xl italic leading-relaxed text-navy lg:text-2xl">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
              </div>
              <figcaption className="mt-8 border-t hairline-gold pt-5">
                <p className="font-sans text-sm font-semibold uppercase tracking-[0.18em] text-navy">{t.name}</p>
                <p className="mt-1 text-sm text-muted">{t.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
